var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 .667C1.265.667.665 1.267.665 2s.6 1.333 1.333 1.333c.734 0 1.334-.6 1.334-1.333S2.733.667 1.999.667z",
    stroke: "#3E3F58",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
export default SvgDot;